import httpClient from '../base/httpClient';
import { UserOrderPanelDto } from '../../interfaces/UserOrderPanelDto';

export const UserOrderAPI = {
  getUserRequests: async () => {
    return await httpClient.get<UserOrderPanelDto[]>('/order/user/requests');
  },
};
